<template>
  <div>
    <header-component />
    <div
      :class="
       isAddPage ? 'px-2 pt-2 pb-2 w-full' : 'container-fluid pt-2'
      "
    >
      <form class="needs-validation" @submit.prevent="checkForm()">
        <div class="card">
          <div class="card-header">
            <h3 class="mb-0" style="text-transform: capitalize">
              Add Service Request
            </h3>
            <div class="col-lg-12 col-5 text-right">
              <base-button size="sm" type="primary" @click="openCustomerModal"
                >New Customer</base-button
              >
              <base-button
                size="sm"
                type="default"
                :disabled="!canEditSelectedCustomer"
                @click="openEditCustomerModal"
                >Edit Customer</base-button
              >
              <base-button size="sm" type="primary" @click="refreshPage()"
                >Refresh</base-button
              >
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <base-input label="Date">
                  <el-date-picker
                    ref="date"
                    v-model="serviceRequest.date"
                    type="date"
                    style="width: 100%"
                  />
                </base-input>
              </div>
              <div class="col-md-2">
                <base-input label="Customer By Name" tabindex="0">
                  <el-select
                    clearable
                    ref="customerInput"
                    v-model="serviceRequest.userId"
                    :class="{
                      'is-invalid': formErrors.find(
                        i => i.field === 'customer-name'
                      )
                    }"
                    filterable
                    remote
                    :remote-method="filterUserByName"
                    :loading="loading"
                    @change="getAddressesOnChangeOfCustomer"
                  >
                    <div v-if="filteredUsers.length > 0">
                      <el-option
                        v-for="(item, index) in filteredUsers"
                        :key="index"
                        :value="item.userId"
                        :label="
                          item.firstName +
                            ' ' +
                            item.lastName +
                            ' (' +
                            item.phone +
                            ')'
                        "
                      />
                    </div>
                    <div
                      v-if="
                        filteredUsers.length === 0 && searchedQuery.length > 0
                      "
                    >
                      <el-option
                        key="add-new"
                        value="add-new"
                        label="Add New"
                      />
                    </div>
                  </el-select>
                </base-input>
              </div>
              <div class="col-md-2">
                <base-input label="Customer By Phone" tabindex="0">
                  <el-select
                    clearable
                    ref="customerInput"
                    v-model="serviceRequest.userId"
                    :class="{
                      'is-invalid': formErrors.find(
                        i => i.field === 'customer-name'
                      )
                    }"
                    filterable
                    remote
                    :remote-method="filterUserByPhone"
                    :loading="loading"
                    @change="getAddressesOnChangeOfCustomer"
                  >
                    <div v-if="filteredUsers.length > 0">
                      <el-option
                        v-for="(item, index) in filteredUsers"
                        :key="index"
                        :value="item.userId"
                        :label="
                          item.firstName +
                            ' ' +
                            item.lastName +
                            ' (' +
                            item.phone +
                            ')'
                        "
                      />
                    </div>
                    <div
                      v-if="
                        filteredUsers.length === 0 && searchedQuery.length > 0
                      "
                    >
                      <el-option
                        key="add-new"
                        value="add-new"
                        label="Add New"
                      />
                    </div>
                  </el-select>
                </base-input>
              </div>
              <div class="col-md-3" v-if="serviceRequest.userId">
                <base-input label="Select Address" tabindex="0">
                  <span v-if="showAddressLoader">
                    <i class="el-icon-loading" />
                    Loading Address...
                  </span>
                  <el-select
                    v-else
                    v-model="serviceRequest.customerAddressId"
                    :class="{
                      'is-invalid': formErrors.find(i => i.field === 'address')
                    }"
                    filterable
                  >
                    <el-option
                      v-for="(item, index) in customerAddresses"
                      :key="index"
                      :value="item.customerAddressId"
                      :label="item.address + ',(' + item.addressMarathi + ')'"
                    />
                  </el-select>
                </base-input>
              </div>
              <div class="col-md-3">
                <base-input label="Type" tabindex="1">
                  <el-radio v-model="serviceRequest.isOnSite" :label="true"
                    >On Site</el-radio
                  >
                  <el-radio v-model="serviceRequest.isOnSite" :label="false"
                    >In House</el-radio
                  >
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <base-input label="Select Service" tabindex="3">
                  <el-cascader
                    :options="options"
                    :props="{ multiple: true }"
                    v-model="serviceRequest.serviceJobsMeta"
                    :class="{
                      'is-invalid': formErrors.find(i => i.field === 'service')
                    }"
                    filterable
                    style="width: 100%"
                    @change="getVendorsByServiceCategory"
                  >
                    <template slot-scope="{ node, data }">
                      <div v-if="data.value === 2">
                        <span>
                          <a @click="openServiceModal(node)">{{
                            data.label
                          }}</a>
                        </span>
                      </div>
                      <div v-else-if="data.value === 3">
                        <span>
                          <a @click="openServiceJobModal(node)">{{
                            data.label
                          }}</a>
                        </span>
                      </div>
                      <div v-else>
                        <span>{{ data.label }}</span>
                        <span v-if="!node.isLeaf">
                          ({{ data.children.length }})
                        </span>
                      </div>
                    </template>
                  </el-cascader>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <base-input label="Select Priority">
                  <el-radio-group v-model="serviceRequest.priority">
                    <el-radio label="high">High</el-radio>
                    <el-radio label="moderate">Moderate</el-radio>
                    <el-radio label="low">Low</el-radio>
                  </el-radio-group>
                </base-input>
              </div>
              <div class="col-md-3">
                <base-input label="Temporary Phone" tabindex="5">
                  <el-input
                    v-uppercase
                    v-model="serviceRequest.temporaryPhone"
                    type="text"
                  />
                </base-input>
              </div>
              <div class="col-md-3">
                <base-input label="Description" tabindex="5">
                  <el-input
                    v-uppercase
                    v-model="serviceRequest.description"
                    type="text"
                  />
                </base-input>
              </div>
              <div class="col-md-3">
                <base-input label="Select Vendor" tabindex="4">
                  <el-select v-model="serviceRequest.vendorId" filterable>
                    <el-option
                      v-for="(item, index) in vendors"
                      :key="index"
                      :value="item.vendorId"
                      :label="item.firstName + ' ' + item.lastName"
                    />
                  </el-select>
                </base-input>
              </div>
            </div>

            <base-button
              :disabled="showLoader ? true : false"
              md
              type="primary"
              native-type="submit"
            >
              <span v-if="showLoader" class="btn-inner--icon"
                ><i class="fas fa-spinner fa-spin" />
              </span>
              <span class="btn-inner--text">Save</span></base-button
            >
          </div>
        </div>
      </form>
      <el-dialog :visible.sync="serviceModal" title="Add Service">
        <add-service @close="closeServiceModal()" />
      </el-dialog>
      <el-dialog :visible.sync="serviceJobModal" title="Add Service Job">
        <add-service-job @close="closeServiceJobModal()" />
      </el-dialog>
      <el-dialog
        :visible.sync="showCreateUserModal"
        title="Add User"
        width="60%"
      >
        <create-user
          :redirect-to-users="false"
          :customer-type="true"
          :searchedField="searchedQuery"
          @close="closeUserModal()"
        />
      </el-dialog>
      <el-dialog
        :visible.sync="showEditCustomerModal"
        title="Edit Customer"
        width="60%"
        @closed="onEditCustomerModalClosed"
      >
        <create-user
          v-if="showEditCustomerModal"
          :redirect-to-users="false"
          :customer-type="true"
          @close="closeEditCustomerModal"
          @customer-updated="refreshSelectedCustomerData"
        />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import {
  Select,
  Option,
  Autocomplete,
  DatePicker,
  Radio,
  Cascader,
  Dialog,
  RadioGroup
} from "element-ui";
import { format } from "date-fns";
import HeaderComponent from "../../views/Components/HeaderComponent";
import createUser from "../User/CreateUserComponent";

import AddService from "../Service/AddService.vue";
import AddServiceJob from "../ServiceJob/AddServiceJob";
import Validator from "@/plugins/customValidator";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Autocomplete.name]: Autocomplete,
    [Radio.name]: Radio,
    [Cascader.name]: Cascader,
    [Dialog.name]: Dialog,
    [RadioGroup.name]: RadioGroup,
    "header-component": HeaderComponent,
    "create-user": createUser,

    "add-service": AddService,
    "add-service-job": AddServiceJob
  },
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  data: () => {
    return {
      searchedQuery: "",
      filteredUsers: [],
      loading: false,
      selectedServiceJobs: [],
      options: [],
      showCreateUserModal: false,
      showEditCustomerModal: false,
      customers: [],
      serviceModal: false,
      serviceJobModal: false,
      formErrors: [],
      showLoader: false,
      customerAddresses: [],
      showCustomerLoading: false,
      showAddressLoader: false
    };
  },

  computed: {
    ...mapState("serviceRequest", ["serviceRequest"]),
    ...mapGetters({
      statuses: "status/getStatusList",
      customerList: "user/getCustomerList",
      user: "user/getLoggedInUser",
      vendors: "vendor/getVendorList"
    }),
    users() {
      return this.customerList.rows;
    },
    canEditSelectedCustomer() {
      const id = this.serviceRequest.userId;
      return Boolean(id && this.isUUID(id));
    },
    isAddPage() {
      return !this.$route.params.id;
    }
  },
  watch: {
    customerList(value) {
      const customers = value.rows.map(i => {
        if (i.customerType === "society") {
          i.label = `${i.name}, ${i.locality} ${i.phone}`;
        } else {
          i.label = `${i.firstName} ${i.lastName}, ${i.phone}`;
        }
        return i;
      });
      this.customers = customers.sort(function(a, b) {
        var nameA = a.firstName.toUpperCase(); // ignore upper and lowercase
        var nameB = b.firstName.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      this.showCustomerLoading = false;
    }
  },
  async mounted() {
    this.showCustomerLoading = true;

    if (!this.$route.params.id) {
      this.$refs.customerInput.$el.click();
    }
    this.getStatusList();
    this.getVendors({ isActive: true });
    this.options = await this.getNestedServiceCategories();

    if (this.$route.params.id) {
      this.showAddressLoader = true;
      this.getServiceRequest(this.$route.params.id);
      this.getAddresses();
      this.setUser();
    }

    document.addEventListener("keydown", this.keyListener.bind(this));
  },

  methods: {
    ...mapActions({
      getStatusList: "status/getStatusList",
      getUsers: "user/getUsers",
      saveServiceRequest: "serviceRequest/saveServiceRequest",
      updateServiceRequest: "serviceRequest/updateServiceRequest",
      getServiceRequestList: "serviceRequest/getServiceRequestList",
      fetchServiceCategories: "serviceCategory/getServiceCategoryList",
      fetchServices: "service/getServicesByCategoryId",
      fetchServiceJobs: "job/getServiceJobsByService",
      getNestedServiceCategories: "serviceCategory/getNestedServiceCategories",
      getVendors: "vendor/getVendorList",
      getServiceRequest: "serviceRequest/fetchServiceRequest",
      getCustomerAddresses: "user/getCustomerAddresses",
      searchUsers: "user/searchUsers",
      fetchUser: "user/fetchUser"
    }),

    getAddressesOnChangeOfCustomer(userId) {
      if (userId) {
        const ifUUId = this.isUUID(userId);
        if (ifUUId) {
          this.serviceRequest.customerAddressId = null;
          this.getCustomerAddresses(userId).then(res => {
            this.customerAddresses = res.data;
            if (this.serviceRequest.customerAddressId === null) {
              this.serviceRequest.customerAddressId = this.customerAddresses[0].customerAddressId;
            }
          });
          this.showAddressLoader = false;
        } else {
          if (/^\d+$/.test(this.searchedQuery)) {
            this.setPrimaryCustomerData({ phone: this.searchedQuery });
          } else {
            this.setPrimaryCustomerData({ name: this.searchedQuery });
          }
        }
      }
    },

    isUUID(userId) {
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      return uuidRegex.test(userId);
    },
    getAddresses() {
      if (this.serviceRequest.userId) {
        this.getCustomerAddresses(this.serviceRequest.userId).then(res => {
          this.customerAddresses = res.data;
          this.showAddressLoader = false;
          if (this.serviceRequest.customerAddressId === null) {
            this.serviceRequest.customerAddressId = this.customerAddresses[0].customerAddressId;
          }
        });
      }
    },

    ...mapMutations({
      resetServiceRequest: "serviceRequest/resetServiceRequest",
      setService: "service/setService",
      resetService: "service/resetService",
      setServiceJob: "serviceJob/setJob",
      resetJob: "serviceJob/resetJob",
      resetUser: "user/resetUser",
      prefillUser: "user/prefillUser"
    }),

    checkForm() {
      this.formErrors = [];
      const serviceRequestErrors = Validator.validateServiceRequest(
        this.serviceRequest
      );
      this.formErrors = [...serviceRequestErrors];
      if (!this.formErrors.length) {
        this.showLoader = true;
        this.submitServiceRequest();
      } else {
        this.formErrors.forEach(i => {
          this.$notify({
            message: i.msg,
            type: "danger",
            title: "Validation Error"
          });
        });
      }
    },

    submitServiceRequest() {
      this.serviceRequest.serviceRequestJobs = this.selectedServiceJobs;
      if (this.showLoader === true) {
        if (this.serviceRequest.serviceJobsMeta.length > 5) {
          this.$notify({
            message: "You can select upto 5 services at a time",
            type: "danger",
            title: "Validation Error"
          });
          this.showLoader = false;
          return;
        }
        const result = this.serviceRequest.serviceJobsMeta.filter(
          i => i.length === 2
        );
        if (result.length) {
          this.$notify({
            message: "Invalid services selected",
            type: "danger",
            title: "Validation Error"
          });
          this.showLoader = false;
          return;
        }

        if (this.serviceRequest.serviceRequestId) {
          if (this.serviceRequest.status.code === "pending") {
            if (this.serviceRequest.vendorId) {
              const assignedStatus = this.statuses.find(
                i => i.code === "assigned"
              );

              this.serviceRequest.statusId = assignedStatus.statusId;
              this.serviceRequest.status = {
                code: "assigned",
                label: "Assigned"
              };
            }
          }
          this.updateServiceRequest().then(() => {
            this.$notify({
              message: "Service Request Updated Succesfully!",
              type: "success",
              title: "Succes"
            });
            this.getServiceRequestList();
            this.$router.push("/serviceRequests/list");
            this.showLoader = false;
          });
        } else {
          this.serviceRequest.createdBy = this.user.userId;
          this.saveServiceRequest().then(() => {
            this.$notify({
              message: "Service Request Created Succesfully!",
              type: "success",
              title: "Success"
            });
            this.getServiceRequestList();
            this.$router.push("/serviceRequests/list");
            this.showLoader = false;
          });
        }
      }
    },

    async setUser() {
      if (this.serviceRequest.userId) {
        const data = await this.getUsers({
          userId: this.serviceRequest.userId
        });
        this.filteredUsers = data.rows;
      }
    },
    openCustomerModal() {
      this.resetUser();
      this.showCreateUserModal = true;
    },
    async openEditCustomerModal() {
      if (!this.canEditSelectedCustomer) return;
      try {
        await this.fetchUser(this.serviceRequest.userId);
        this.showEditCustomerModal = true;
      } catch (e) {
        this.$notify({
          message: "Could not load customer for editing",
          type: "danger",
          title: "Error"
        });
      }
    },
    closeEditCustomerModal() {
      this.showEditCustomerModal = false;
      this.getUsers({ role: "Customer", perPage: 1000 });
    },
    onEditCustomerModalClosed() {
      this.resetUser();
    },
    refreshSelectedCustomerData() {
      const uid = this.serviceRequest.userId;
      if (!uid || !this.isUUID(uid)) return;
      const prevAddressId = this.serviceRequest.customerAddressId;
      this.showAddressLoader = true;
      this.getUsers({ userId: uid })
        .then(data => {
          if (data && data.rows) {
            this.filteredUsers = data.rows;
          }
        })
        .catch(() => {});
      this.getCustomerAddresses(uid)
        .then(res => {
          this.customerAddresses = res.data || [];
          const stillHere = this.customerAddresses.some(
            a => a.customerAddressId === prevAddressId
          );
          if (stillHere) {
            this.serviceRequest.customerAddressId = prevAddressId;
          } else if (this.customerAddresses.length) {
            this.serviceRequest.customerAddressId = this.customerAddresses[0].customerAddressId;
          } else {
            this.serviceRequest.customerAddressId = null;
          }
        })
        .catch(() => {
          this.$notify({
            message: "Could not refresh addresses",
            type: "warning",
            title: "Warning"
          });
        })
        .finally(() => {
          this.showAddressLoader = false;
        });
    },
    setPrimaryCustomerData(data) {
      this.prefillUser(data);
      this.showCreateUserModal = true;
    },
    keyListener(e) {
      if (e.ctrlKey && e.key === "c") {
        this.$refs.customerInput.focus();
      } else if (e.ctrlKey && e.key === "d") {
        e.preventDefault();
        this.$refs.date.focus();
      } else if (e.ctrlKey && e.key === "s") {
        e.preventDefault();
      }
    },
    async refreshPage() {
      this.getVendors();
      this.options = await this.getNestedServiceCategories();
    },
    closeUserModal() {
      this.getUsers({ role: "Customer", perPage: 1000 });
      this.showCreateUserModal = false;
    },
    openServiceModal(node) {
      this.setService({ serviceCategoryId: node.parent.data.value });
      this.serviceModal = true;
    },
    async closeServiceModal() {
      this.options = await this.getNestedServiceCategories();
      this.serviceModal = false;
      this.resetService();
    },
    openServiceJobModal(node) {
      const data = {
        service: {
          serviceCategoryId: node.parent.parent.data.value
        },
        serviceId: node.parent.data.value
      };
      this.setServiceJob(data);
      this.serviceJobModal = true;
    },
    async closeServiceJobModal() {
      this.options = await this.getNestedServiceCategories();
      this.serviceJobModal = false;
      this.resetJob();
    },
    getVendorsByServiceCategory(data) {
      if (data.length > 0) {
        const query = {
          serviceCategoryId: data[0][0],
          isActive: true
        };
        this.getVendors(query);
      }
    },
    filterUserByName(query) {
      this.searchedQuery = query;
      if (query !== "") {
        this.loading = true;
        this.searchUsers({ name: query })
          .then(res => {
            this.filteredUsers = res;
            this.loading = false;
          })
          .catch(err => {
            if (err.status === 422) {
              this.filteredUsers = [];
            }
          });
      } else {
        this.options = [];
      }
    },
    filterUserByPhone(query) {
      this.searchedQuery = query;
      if (query !== "") {
        this.loading = true;
        this.searchUsers({ phone: query })
          .then(res => {
            this.filteredUsers = res;
            this.loading = false;
          })
          .catch(err => {
            if (err.status === 422) {
              this.filteredUsers = [];
            }
          });
      } else {
        this.options = [];
      }
    },
    restrictToDigits(event) {
      const input = event.target.value;
      const sanitizedInput = input.replace(/\D/g, "");
      event.target.value = sanitizedInput;
      this.searchedQuery = sanitizedInput; // Assuming you're using this for searching
    }
  }
};
</script>
<style>
.service-request-autocomplete {
  width: 100%;
}

.el-cascader-menu__wrap {
  height: 204px !important;
}

.el-cascader-node:not(.is-disabled):focus,
.el-cascader-node:not(.is-disabled):hover {
  background: #5e72e4;
  color: #ffffff;
}
</style>
